import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ContentBanner } from '@xingternal/banner';
import { Button as ButtonComponent } from '@xingternal/button';
import { mediaConfined, mediaSmallOrTiny } from '@xingternal/layout-tokens';
import { Toggle as ToggleComponent } from '@xingternal/toggle';
import { spaceM, spaceS, xdlColorText } from '@xingternal/tokens';
import { BodyCopy } from '@xingternal/typography';

export const Banner = styled(ContentBanner)`
  /* we reduce z-index so the error banner is always on top */
  z-index: 150;

  @media ${mediaConfined} {
    justify-content: center;
  }
`;

export const Icon = styled.svg`
  flex-shrink: 0;
`;

export const Body = styled(BodyCopy)`
  margin: 0 ${spaceM} 0 ${spaceS};

  @media ${mediaSmallOrTiny} {
    flex-grow: 1;
  }
`;

export const AlertsAnchor = styled(Link)`
  color: ${xdlColorText};
  font-weight: 700;
`;

export const Toggle = styled(ToggleComponent)`
  flex-shrink: 0;
`;

export const Button = styled(ButtonComponent)`
  flex-shrink: 0;
`;
